/*
 * WaWiZuteilungenApp.jsx
 *
 * Created by Dr. Maximillian Dornseif 2021-11-28 in huWaWi3 24.5.4
 * Copyright (c) 2021, 2022 HUDORA GmbH
 */

import gql from 'graphql-tag'
import React from 'react'

import { ZUTEILUNG_FRAGMENT } from '../fragments'
import { KindPage } from '../lib/components/KindPage'

/** Rendert entweder die Startseite (Suche) oder eine Gruppenseite
 * */
export const IcZuteilungenApp = (props) => {
  return (
    <KindPage
      basePath={'/ic'}
      componentPath={'zuteilung'}
      schemaName={'HwIcZuteilung'}
      title={'Zuteilungen'}
      listQuery={ZUTEILUNG_LIST_QUERY}
      entityQuery={ZUTEILUNG_QUERY}
    ></KindPage>
  )
}

export const ZUTEILUNG_LIST_QUERY = gql`
  query Zuteilungen($cursor: String) {
    nodes: hwIcZuteilungPages(after: $cursor) {
      edges {
        cursor
        node {
          ...zuteilungFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ZUTEILUNG_FRAGMENT}
`

const ZUTEILUNG_QUERY = gql`
  query Zuteilung($nr: ID!) {
    entity: hwIcZuteilung(designator: $nr) {
      ...zuteilungFragment
    }
  }
  ${ZUTEILUNG_FRAGMENT}
`
